import { render } from "./TypeRecetteModal.vue?vue&type=template&id=659d9e30&ts=true"
import script from "./TypeRecetteModal.vue?vue&type=script&lang=ts"
export * from "./TypeRecetteModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__